import { BaseSystemFields, GeneralListRequest } from './common.model'

export interface LandingPageProjectInfo {
	id: string
	code: string
	display_name: string
	reference_code: string
	session_limit?: number
	seat_limit?: number
	web_x_coord?: number
	web_y_coord?: number
	x_coord: number
	y_coord: number
	product_modules?: {
		id: string
		code: string
		display_name: string
		url: string
		enable: boolean
	}[]
	district?: string
	attributes: ProjectAttribute[]
}

export interface MyProfileProjectList {
	projects: string
	organisation: string
}

export interface ProductModule {
	id?: string
	start_at?: Date
	expires_at?: Date
	project_id?: string
	product_id?: string // for product
	module_id?: string //for module
	dashboard_url?: string
	icon_url?: string
	isSubscribe?: boolean //for frontend display subscription
	item_type?: string
	item_id?: string
}

export interface ProjectInfo {
	id?: string
	code?: string
	display_name?: string
	reference_code?: string
	session_limit?: number
	seat_limit?: number
	web_x_coord?: number
	web_y_coord?: number
	x_coord?: number
	y_coord?: number
	base_system_field?: BaseSystemFields
	subscriptions?: {
		id?: string
		purchase_order_id?: string
		project_id?: string
		item_id?: string
		item_type?: string
		icon_url?: string
		code?: string
		display_name?: string
	}[]
	project_module_configs?: ProductModule[]
	project_product_configs?: ProductModule[]
	userGroupSubscribItems?: any
	userGroupName?: any
	attributes: ProjectAttribute[]
}

export interface ProjectInfoTableData {
	id?: string
	org_ids?: string[]
	project_id?: string
	display_name?: string
}

export interface ListProjectsRequest extends GeneralListRequest {
	code?: {
		operator: string
		value: string
	}
	display_name?: {
		operator: string
		value: string
	}
	project_ids?: {
		operator: string
		value: string[]
	}
	purchase_order_ids?: {
		operator: string
		value: string[]
	}
	active?: {
		operator: '='
		value: boolean[]
	}
	is_deleted?: {
		operator: '='
		value: boolean[]
	}
	skip_project_search?: boolean
	with_product_modules?: boolean
}

export enum ProjectAttributeKey {
	ServiceSuspension = 'ServiceSuspension',
}

export interface ProjectAttribute {
	project_id: string
	key: string
	value: string
}

export interface ProjectSuspensionArea {
	hideClose?: boolean

	// default 10s
	allowCloseAfterSeconds?: number

	// HTML code
	content: string
}
